import "./Contact.module.css";
import Navigation from "@/reusable_sections/Header";
import LetsTalkGrowth from "./sections/LetsTalkGrowth";
import ServiceCoverageArea from "./sections/ServiceCoverageArea";
import Footer from "@/reusable_sections/Footer";
export default function ContactPage() {
  return <div>
      <Navigation />
      <LetsTalkGrowth />
      <ServiceCoverageArea />
      <Footer />
    </div>;
}